import { SelectDesktop } from '@cian/ui-kit';
import { EMaxPrepay } from '../../../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectPrepayFilter } from 'shared/selectors/advancedFilters';

export const PrepayContainer: FC = () => {
  const { label, value, options } = useSelector(selectPrepayFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (newValue: EMaxPrepay) => {
      onChange({ action: 'setPrepay', arguments: [newValue === EMaxPrepay.Any ? null : newValue] });
    },
    [onChange],
  );

  return (
    <InlineFilter label={label}>
      <SelectDesktop inline options={options} value={value} onChange={handleChange} />
    </InlineFilter>
  );
};
